// extracted by mini-css-extract-plugin
export default {"header":"Quiz-module__header__Ouj0W"};